module.exports = __webpack_public_path__ + "img/1487468845.672a4447.jpg";